import React from 'react';

import HowItWorksStep1SVG from "../../components/Images/HowItWorksStep1SVG"
import HowItWorksStep2SVG from "../../components/Images/HowItWorksStep2SVG"
import HowItWorksStep3SVG from "../../components/Images/HowItWorksStep3SVG"
import HowItWorksStep4SVG from "../../components/Images/HowItWorksStep4SVG"
import  KavitaImg from "../../pages/WritersBenefit/Author/Images/Kavita.jpg"
import  WordsImg from "../../pages/WritersBenefit/Author/Images/Words.jpg"
import  AnandImg from "../../pages/WritersBenefit/Author/Images/Anand.jpg"
import { commonFAQ } from '../../constants';



const hindi = {
  introduction_heading :'Become the writer of your dreams! ',
  create_novel_button_text: "Create A New Novel ",
  rewards_title: <>  Rewards &amp; Benefits 🌟</>,
  rewards_para_text: <> <span> Earn min <strong>3.5k dollars</strong> &amp; up to <strong>10k dollars</strong> per book per year</span> </>,
  rewardsAndBenefitsArray: [
    {
      heading: 'New Story Bonus 🖋️',
      subHeading: <>This reward is given to <strong>every signed original story</strong> when you publish the minimum words</>,
      tableHeadings: ['Minimum Words ', 'Reward 💰'],
      table: [
        {
          wordCount: '30,000',
          reward: '$50',
        },
      ],
      note: <><strong>No Plagiarised</strong> or Hate content</>,
      extraNotes: [
        {
          no: 1,
          text: 'The writer has to raise the request to apply for the Writer Benefit Program [WBP] & sign the contract.',
        },
        {
          no: 2,
          text: '.The contract can be signed as early as 5000 word count and payment cycle starts on the 1st week of next month after hitting 30,000 words.',
        },
      ],
    },
    {
      heading: 'Daily Update Bonus ⭐',
      subHeading: 'This reward will be based on published quantity & quality every month',
      tableHeadings: ['Word Count (Monthly)', 'Reward 💰'],
      table: [
        {
          wordCount: 'Less than 30,000   ',
          reward: 'No payment',
        },
        {
          wordCount: '30,000 - 40,000',
          reward: '$100',
        },
        {
          wordCount: '40,000 - 50,000',
          reward: '$150',
        },
        {
          wordCount: 'More than 50,000  ',
          reward: '$200',
        },
      ],
      note: <>The writers can <strong>miss publishing</strong> chapters for a <strong>maximum of 5 days</strong> in a month.</>,
      extraNotes: [
        {
          no: 1,
          text: <> After the author's writer benefit program application is approved, the eligible reward will be calculated on the 1st of every month.</>,
        },
        {
          no: 2,
          text: <> Wherein, <strong>Payment Cycle </strong>for the received reward will be on the <strong>8th of every month, </strong> given the <strong>contract is signed before the 1st of the month</strong></>,
        },
      ],
    },
    {
      heading: 'Completion Bonus 🚀',
      subHeading: 'This reward will be given to the author when he/she request to complete the story',
      tableHeadings: ['Word Count (Overall)', 'Reward 💰'],
      table: [
        {
          wordCount: ' Less than  200,000 ',
          reward: 'No Payment',
        },
        {
          wordCount: '200,000 - 300,000',
          reward: '$400',
        },
        {
          wordCount: '300,000 - 400,000',
          reward: '$650',
        },
        {
          wordCount: '400,000 - 500,000',
          reward: '$900',
        },
        {
          wordCount: ' More than 500,000 ',
          reward: '$1200',
        },
      ],
      note: <>The story should have a satisfying ending </>,
      extraNotes: [
        {
          no: 1,
          text: <> Send an email to our official account : writers@pocketfm.com, with the subject title : &#91;Book Name&#93; &#91;Author Name&#93; Request for Completion Bonus </>,
        },
        {
          no: 2,
          text: <>The payment would be approved after an editorial check to evaluate if the book meets our content quality guidelines.</>,
        },
      ],
    },
  ],
  deadline_content: <>   <span>Deadline To Enter Program </span><span role="img" aria-label="finish flag">🏁</span>   </>,
  deadline_to_enter_button: "Be a Pocket Novel Writer ",
  deadline_date:31,
  deadline_date_suffix:"",
  days_or: "days or " ,
  months_to_go:" months to go !! ",
  monthInWords:"October",
  month:9,
  year: 2022,
  deadline_subheading: <>Once part of the program, you will be eligible for <strong>all</strong> the above <strong>bonuses for lifetime</strong></>,
  howItWorksArray : [
    {
      step: '1',
      instruction:<>Write the first 30,000 words &amp; apply for Contract✍️</>,
        stepSVG:HowItWorksStep1SVG
    },
    {
      step: '2',
      instruction:<>Sign the Contract &amp; Receive <strong> New Story Bonus</strong> 💸 💰</>,
        stepSVG:HowItWorksStep2SVG
  
    },
    {
      step: '3',
      instruction:<>Update Chapters daily, and receive <strong>Daily Publish Bonus</strong> every <strong>Month</strong> 💸 💰</>,
        stepSVG:HowItWorksStep3SVG
  
    },
    {
      step: '4',
      instruction:<>Once you finish 2,50,000 words and have great reader reviews, you are eligible for your story to be made into an audiobook. After approval, receive Performance Bonus 💰 💸</>,
        stepSVG:HowItWorksStep4SVG
  
    },
  ],
  step: "step",
  popularWritersArray : [
    {
      writerName: 'kavita verma ',
      novelName: 'Mein tere chandani',
      plays: '9.8M',
      words: '820K',
      writerImgSrc: KavitaImg,
    },
    {
      writerName: 'Words Queen',
      novelName: 'Fake Love',
      plays: '7.7M',
      words: '540K',
      writerImgSrc: WordsImg,
    },
    {
      writerName: 'Anand Usha Borkar',
      novelName: 'Megh - Ek Shraap',
      plays: '1.8M',
      words: '720K',
      writerImgSrc: AnandImg,
    },
  ],
  popular_writter: 'Popular Writers ',


  faq: <strong>Frequently Asked Questions </strong>,
  frequentlyAskedQuestionsArray : commonFAQ,
  
  write_home_earn_stable_income_text :'Write at home & Earn a stable income.',
  write_home_earn_stable_income_subheading : "Start your journey. Gain millions of reads. Earn upto 10,000 dollars per book per year.",
  create_new_novel :"Create A New Novel "
 
}

// console.log(hindi.writer_dream_text)
export default hindi;
